import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PeopleIcon from '@mui/icons-material/People';
import { blue } from '@mui/material/colors';

import { TeamName } from '../types';

type MovePlayerDialogProps = {
  readonly open: boolean;
  readonly onClose: (value?: string) => void;
  readonly toTeams: TeamName[];
};

export default function MovePlayerDialog({
  open,
  onClose,
  toTeams,
}: MovePlayerDialogProps) {
  const handleClose = () => {
    onClose(undefined);
  };

  const handleListItemClick = (value: string) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Move player to</DialogTitle>
      <List sx={{ pt: 0 }}>
        {toTeams.map((team) => (
          <ListItem button onClick={() => handleListItemClick(team)} key={team}>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                <PeopleIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={`Team ${team}`} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}
